import { Col, Row } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { cloneElement, CSSProperties, ReactElement } from 'react';
import { StyledIconWrapper, StyledIconWrapperTypes } from 'components/new-ui/base/wrappers/styles';
import { H3, SecondaryText } from 'components/new-ui/base/typography/styles';

type Props = {
    title: string;
    subtitle?: ReactElement;
    action?: ReactElement;
    style?: CSSProperties;
    iconProps: {
        icon: ReactElement;
        type: StyledIconWrapperTypes;
    };
};

const HeaderWithIcon = ({ title, subtitle, action, iconProps, style }: Props) => {
    const iconFontSize = 20;
    const { icon, type } = iconProps;

    const defaultIcon = (
        <StyledIconWrapper $type={iconProps.type} $size="small">
            <InfoCircleOutlined
                style={{
                    fontSize: iconFontSize,
                    color: 'currentColor',
                }}
            />
        </StyledIconWrapper>
    );
    return (
        <Row gutter={16} wrap={false} style={style}>
            <Col flex="none">
                {icon ? (
                    <StyledIconWrapper $type={type} $size="small">
                        {cloneElement(icon, {
                            style: { fontSize: iconFontSize, ...icon.props?.style },
                        })}
                    </StyledIconWrapper>
                ) : (
                    defaultIcon
                )}
            </Col>

            <Col flex="auto" style={{ minWidth: 0 }}>
                <H3>{title}</H3>
                <SecondaryText>{subtitle}</SecondaryText>
            </Col>

            {action && <Col flex="none">{action}</Col>}
        </Row>
    );
};

export default HeaderWithIcon;
